// extracted by mini-css-extract-plugin
export default {"chart_box":"EnergySavingAmount_chart_box__cG3iB","spin_box":"EnergySavingAmount_spin_box__ZDkKm","empty_box":"EnergySavingAmount_empty_box__OyAb+"};